var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.inspectComponent,{ref:"inspection",tag:"component",attrs:{"service":_vm.service,"checklist-type":_vm.service.checklist_type,"can-update":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }